import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'

import { TenantConfiguration } from '../../domain/models'
import { SearchTerm, TenantConfigurationCoordinate } from '../../domain/models/TenantConfiguration'
import { ITenantProvider } from '../../domain/providers/TenantProvider'
import routes from './routes'
import { ITenantConfigurationData } from './types'

class TenantProvider implements ITenantProvider {
  public http: AxiosInstance

  constructor(baseURL: string) {
    const config: AxiosRequestConfig = {
      baseURL: `${baseURL}/api/v1`,
      headers: {
        'content-type': 'application/json'
      }
    }
    this.http = axios.create(config)
  }

  private static toTenantConfiguration(data: ITenantConfigurationData): TenantConfiguration {
    let initialCoordinate: TenantConfigurationCoordinate | undefined = undefined
    if (data.startingCoorLong && data.startingCoorLat) {
      initialCoordinate = {
        latitude: data.startingCoorLat,
        longitude: data.startingCoorLong
      }
    }

    let mostPopularTags: Array<SearchTerm> = []
    let mostPopularWasteTypes: Array<SearchTerm> = []

    if (data.mostPopularSearches?.tags) {
      mostPopularTags = data.mostPopularSearches.tags.map((it) => ({
        name: it.replaceAll('_', ' '),
        fullName: `TAG_${it}`
      }))
    }

    if (data.mostPopularSearches?.wasteTypesIds) {
      mostPopularWasteTypes = data.mostPopularSearches.wasteTypesIds.map((it) => ({
        name: it.replaceAll('_', ' '),
        fullName: `WT_${it}`
      }))
    }

    return new TenantConfiguration({
      tenantId: data.tenantId,
      primaryColor: data.color && data.color.replace(' ', ''),
      fontColor: data.whiteFontColor ? 'white' : 'black',
      minZoomLevel: data.minZoomLevel,
      startingZoomLevel: data.startingZoomLevel,
      initialCoordinate,
      geolocationEnabled: data.featureGeolocationActivated,
      dropOffSubmitEnabled: data.featureSubmitDropoffActivated,
      brandProgram: data.brandProgram,
      mostPopularTags,
      mostPopularWasteTypes,
      wasteTypeIds: data.wasteTypesIds,
      displayOnlyBrandProgramStores: data.displayOnlyBrandProgramStores
    })
  }

  async fetchTenantConfiguration(tenantId: string): Promise<TenantConfiguration> {
    const { data } = await this.http.get<ITenantConfigurationData>(
      routes.TENANT_CONFIGURATION.replace('<tenant_id>', tenantId)
    )
    return TenantProvider.toTenantConfiguration(data)
  }
}

export default TenantProvider
